import { Grid, TextField, MenuItem } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormContent } from 'scenes/Producer/Product/EditProduct/components/FormContent';
import styles from 'scenes/Producer/Product/NewProduct/components/Forms/styles';
import { getDeliveryIntegrationActiveList } from 'store/Orbita/Product/actions';
import { EChargeType } from 'v2/interfaces/product';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import Correios from './Form/Correios';
import FixedValue from './Form/FixedValue';
import Free from './Form/Free';
import MelhorEnvio from './Form/MelhorEnvio';
import Partner from './Form/Partner';

import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';

const FREE = '1';
const FIXEDVALUE = '2';
const CORREIOS = '3';
const MELHORENVIO = '4';

interface IProps extends DispatchProp<any> {
  delivery: any;
  enabledValidation?: boolean;
  onAddPartner?: any;
  onRemovePartner?: any;
  onChangeRequiredFields?: any;
  loading?: boolean;
  ref?: any;
  fade?: any;
  setRefField?: any;
  product?: IProduct;
  integration: any;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
}

class PhysicalDeliveryMethods extends Component<IProps, IStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };
  handleChange(prop: string, value: any) {
    let { delivery } = this.props;
    delivery[prop] = value;

    if (prop === 'delivery_type' && value === MELHORENVIO) {
      this.getIntegrations();
    }

    this.props.dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery });
  }

  changeState = () => {
    let { onChangeRequiredFields } = this.props;
    if (onChangeRequiredFields) {
      onChangeRequiredFields();
    }
  };
  componentDidUpdate(prevProps: IProps) {
    if (!this.props.loading && this.props.delivery !== prevProps.delivery) {
      this.changeState();
    }
  }

  getIntegrations() {
    this.props.dispatch(getDeliveryIntegrationActiveList());
  }

  componentDidMount() {
    if (!this.props.loading) {
      this.changeState();
    }
    this.getIntegrations();
  }

  render() {
    const { delivery, enabledValidation, onAddPartner, onRemovePartner, product, integration } = this.props;
    const isSubscription = product?.charge_type === EChargeType.SUBSCRIPTION;

    return (
      <FormContent title='Entrega' loading={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SelectType delivery={delivery} product={product} onChange={this.handleChange} />
          </Grid>
          {!isSubscription && delivery?.delivery_type == CORREIOS && <Correios enabledValidation={enabledValidation} />}
          {!isSubscription && delivery?.delivery_type == MELHORENVIO && (
            <MelhorEnvio
              delivery={delivery}
              integration={{
                logisticType: integration.logisticType,
                status: integration.status,
              }}
            />
          )}
          {delivery.delivery_type === FREE && <Free enabledValidation={enabledValidation} />}
          {delivery.delivery_type === FIXEDVALUE && <FixedValue enabledValidation={enabledValidation} />}
          {!delivery.new && <Partner onAddPartner={onAddPartner} onRemovePartner={onRemovePartner} />}
        </Grid>
      </FormContent>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    delivery: state.components.physicalDelivery,
    integration: state.orbita.Product.getDeliveryIntegrationActiveList,
  };
}

const SelectType = ({ delivery, product, onChange }: { delivery: any; product: IProduct; onChange: (field: string, value: string) => void }) => {
  const isBeta = eduzzAccountsService.verifyUserHasBetaModule('delivery_melhor_envio');
  const isSubscription = product?.charge_type === EChargeType.SUBSCRIPTION;
  return (
    <TextField
      id='delivery_type'
      select
      fullWidth
      value={delivery.delivery_type}
      onChange={(e: any) => onChange('delivery_type', e.target.value)}
      label='Tipo de frete'
      InputProps={{
        disableUnderline: true,
      }}
      InputLabelProps={{
        shrink: true,
      }}
    >
      {!isSubscription && <MenuItem value={CORREIOS}>Correios</MenuItem>}
      {!isSubscription && isBeta && <MenuItem value={MELHORENVIO}>Melhor Envio</MenuItem>}
      <MenuItem value={FREE}>Frete Grátis</MenuItem>
      <MenuItem value={FIXEDVALUE}>Valor Fixo</MenuItem>
    </TextField>
  );
};

export default styles(connect(mapStateToProps)(PhysicalDeliveryMethods)) as any;
